import { useEffect, useState } from 'react';

/* Altura da barra "Hosts ao vivo" fixa no rodapé (0 quando não está na tela).
   Botões flutuantes somam esse valor ao `bottom` para ficarem ACIMA da barra, nunca sobre ela. */
export const useLiveBarOffset = () => {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const measure = () => {
      const bar = document.querySelector("[data-testid='live-hosts-bar']");
      setOffset(bar ? Math.ceil(bar.getBoundingClientRect().height) : 0);
    };
    measure();
    const id = setInterval(measure, 1500);
    window.addEventListener('resize', measure);
    return () => { clearInterval(id); window.removeEventListener('resize', measure); };
  }, []);
  return offset;
};
